export default "__VITE_ASSET__49064958__"